/**
 * 极简 hash 路由：#home / #learn(/sec/lesson 深链) / #play
 * 课程内切换用 history.replaceState 更新 hash 不触发重渲染（沿用旧版行为）。
 */
import { useEffect, useState } from 'react';

export type Page = 'home' | 'learn' | 'play';

export interface Route {
  page: Page;
  rest: string[];
}

function parse(): Route {
  const raw = (location.hash || '#home').replace(/^#/, '');
  const parts = raw.split('/').filter(Boolean);
  const base = parts[0];
  if (base === 'learn') return { page: 'learn', rest: parts.slice(1) };
  if (base === 'play') return { page: 'play', rest: [] };
  return { page: 'home', rest: [] };
}

export function useHashRoute(): Route {
  const [route, setRoute] = useState<Route>(parse);
  useEffect(() => {
    const onChange = () => setRoute(parse());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function navigate(hash: string) {
  const target = hash.startsWith('#') ? hash : '#' + hash;
  if (location.hash === target) return;
  location.hash = target;
}
